import { theme as Green } from './green';
import { theme as Blue } from './blue';
import { theme as Purple } from './purple';

export * from './common/colors';
export const themes = {
    Green,
    Blue,
    Purple,
} as const;
